import { MarketingShell } from "./marketing/layout";

// Shared layout for public legal/support pages, inside the marketing shell.
// These pages are opened directly by browsers (including Shopify reviewers) and
// must render correctly without any Shopify session context — the shell is pure
// HTML/CSS, no Polaris, no App Bridge.

interface LegalPageProps {
  title: string;
  children: React.ReactNode;
}

export function LegalPage({ title, children }: LegalPageProps) {
  return (
    <MarketingShell>
      <section className="nm-section--tight" style={{ paddingTop: "clamp(2.5rem, 1.5rem + 4vw, 4.5rem)" }}>
        <div className="nm-wrap">
          <div className="nm-legal">
            <h1>{title}</h1>
            <p className="nm-legal__updated">Last updated: 2026-06-18</p>
            <div style={{ marginTop: "2rem" }}>{children}</div>
          </div>
        </div>
      </section>
    </MarketingShell>
  );
}
